export default  {
    methods: {
        maskSensitiveField: function(obj, ...args) {
//            return substr($item, 0, 4).str_repeat('*', 8);
            return 'maskedField';
        }
    }
}